module.exports = __webpack_public_path__ + "static/media/services-bg-1.4a99272c.webp";